<template>
  <RouterView />
  <NotificationArea />
</template>
<script lang="ts" setup>
import { NotificationArea } from '@brixcrm/vue-kit'
</script>
